module.exports = __webpack_public_path__ + "media/images/flags/za-31ab68efc55818d34da6913c98c848bf.svg";